import { request } from '../../helpers/api/request';

export const deleteUser = async (id: number) => {
    const { data } = await request({
        url: `admin/users/${id}`,
        method: 'DELETE',
    });

    return data;
};
